import { AnalyticsManager, PostHogAdapter } from '@libs/analytics';
import { StatsAdapter } from '@resources/js/analytics/StatsAdapter';
import { postHogConfig } from '@resources/js/analytics/posthog.config';
const analyticsManager = AnalyticsManager.getInstance();
analyticsManager.setAdapter(new StatsAdapter());
analyticsManager.setAdapter(new PostHogAdapter(postHogConfig));
analyticsManager.init();
